<!-- <rr-btn
    type="Secondary"
    size="Small"
    iconStart="user"
    routerLink="/home/user"
    i18n
    >Accounts</rr-btn
> -->
<rr-btn
    type="Secondary"
    size="Small"
    iconStart="home"
    routerLink="/home/companies"
    i18n
    >Companies</rr-btn
>
<rr-btn
    type="Secondary"
    size="Small"
    iconStart="wind"
    routerLink="/home/streams"
    i18n
    >Streams</rr-btn
>
<rr-btn
    type="Secondary"
    size="Small"
    iconStart="download"
    routerLink="/home/figma-exports"
    i18n
    >Figma-Exports</rr-btn
>
<!-- <rr-btn
    type="Secondary"
    size="Small"
    iconStart="wind"
    routerLink="/home/flying-agents"
    i18n
    >Flying Agents</rr-btn
> -->
<!-- <rr-btn
    type="Secondary"
    size="Small"
    iconStart="file"
    routerLink="/home/stream-report"
    i18n
    >Reports</rr-btn
> -->
<rr-btn
    type="Secondary"
    size="Small"
    iconStart="folder"
    routerLink="/home/conversations"
    i18n
    >Conversations</rr-btn
>
<rr-btn
    type="Secondary"
    size="Small"
    iconStart="file"
    routerLink="/home/user-report"
    i18n
>
    User-Report
</rr-btn>
<rr-btn
    type="Secondary"
    size="Small"
    iconStart="box"
    routerLink="/home/categories"
    i18n
    >Domains / Categories</rr-btn
>
<rr-btn
    type="Secondary"
    size="Small"
    iconStart="tag"
    routerLink="/home/tags"
    i18n
    >Tags</rr-btn
>
<rr-btn
    type="Secondary"
    size="Small"
    iconStart="shield"
    routerLink="/home/gdpr"
    i18n
    >GDPR</rr-btn
>
